<template>
    <v-form @submit.prevent="submit">
        <v-autocomplete
            v-model="form.attending"
            :items="relationships"
            no-data-text="No relationships found"
            multiple
            chips
            deletable-chips
            item-text="name"
            item-value="id"
            label="Your relationships"
            outlined
            class="soli-blue-text"
            prepend-inner-icon="people"
            :error-messages="errors.attending"
            hide-details="auto"
        >
            <template v-slot:item="data">
                <v-list-item-avatar>
                    <img :src="data.item.profile_photo_url" />
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title
                        v-html="data.item.name"
                    ></v-list-item-title>
                    <v-list-item-subtitle
                        v-html="data.item.email"
                    ></v-list-item-subtitle>
                </v-list-item-content>
            </template>
        </v-autocomplete>
    </v-form>
</template>

<script>
export default {
    props: {
        relationships: {
            type: Array,
            default: () => [],
        },
        eventRegister: {
            type: Object,
            default: () => {},
        },
        errors: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                event_register_id: null,
                attending: [],
                quantity: null,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(route("shoppingCart.update"), {
                preserveState: true,
                preserveScroll: true,
                onSuccess: () => {
                    this.loading = false;
                    this.$emit("success");
                },
                onError: (errors) => {
                    this.loading = false;
                    console.log(
                        "Form returned errors: " + JSON.stringify(errors)
                    );
                    if (errors.contactSupport) return;
                    if (errors.soliError) return;
                },
            });
        },
    },
};
</script>
